import { AddConsultationDatesRequestData } from '../../../types/models/consultations/consultation.types';
import { InitConsultationRequestData } from '../../../types/api/endpoints/consultations/init.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';
import { SendConsultationAnswerRequestData } from '../../../types/api/endpoints/consultations/answers.types';
import { SendConsultationQuestionRequestData } from '../../../types/api/endpoints/consultations/questions.types';
import { PageQueryParams } from '../../../types/api/api.types';
import { NAF } from '../../../types/api/endpoints/consultations/allNAF.types';
import { NafsQueryParams } from '../../../hooks/fetchers/useNafs/useNafs.types';
import { UseCommercialConsultationsQueryParams } from '../../../hooks/fetchers/useCommercialInProgressConsultations/useCommercialInProgressConsultations.types';

export const CONSULTATIONS_ENDPOINTS = Object.freeze({
  init: (data: InitConsultationRequestData) => api.post(StaticPostEndpoints.Init, data),
  addPrestations: (consultationId: number, data: FormData) =>
    api.post(`consultations/create/prestations/${consultationId}`, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }),
  addDates: (consultationId: number, data: AddConsultationDatesRequestData) =>
    api.post(`consultations/create/dates/${consultationId}`, data),
  confirm: (consultationId: number) => api.put(`consultations/create/confirm/${consultationId}`),

  sendDevis: (data: FormData) => api.post(StaticPostEndpoints.SendDevis, data),
  sendQuestion: (data: SendConsultationQuestionRequestData) =>
    api.post(StaticPostEndpoints.SendQuestion, data),
  sendAnswer: (data: SendConsultationAnswerRequestData) =>
    api.post(StaticPostEndpoints.SendAnswer, data),

  updateDevis: (data: FormData) => api.put(StaticPostEndpoints.UpdateDevis, data),

  updateInfos: (consultationId: number, data: InitConsultationRequestData) =>
    api.put(`consultations/update/infos/${consultationId}`, data),
  close: (consultationId: number) => api.put(`consultations/update/close/${consultationId}`),
  remove: (consultationId: number) => api.put(`consultations/update/remove/${consultationId}`),

  duplicate: (consultationId: number) => api.put(`consultations/duplicate/${consultationId}`),

  allConsultations: (params: PageQueryParams) =>
    api.get(StaticGetEndpoints.AllConsultations, params),

  allCompanyConsultations: (params: PageQueryParams) =>
    api.get(StaticGetEndpoints.AllCompanyConsultations, params),
  allCompanyInProgressConsultations: (params: PageQueryParams) =>
    api.get(StaticGetEndpoints.AllCompanyInProgressConsultations, params),
  allCompanyClosedConsultations: (params: PageQueryParams) =>
    api.get(StaticGetEndpoints.AllCompanyClosedConsultations, params),

  allCommercialInProgressConsultations: (params: UseCommercialConsultationsQueryParams) =>
    api.get(StaticGetEndpoints.AllCommercialInProgressConsultations, {
      ...params,
      fieldsOfActivity: params.fieldsOfActivity || undefined,
    }),

  searchCommercialInProgressConsultations: (
    search: string,
    params: UseCommercialConsultationsQueryParams
  ) =>
    api.get(`consultations/commercial/search/in_progress/${search}`, {
      ...params,
      fieldsOfActivity: params.fieldsOfActivity || undefined,
    }),

  search: (search: string, params: PageQueryParams) =>
    api.get(`/consultations/search/${search}`, params),

  consultationInfos: (consultationId: number) => api.get(`consultations/infos/${consultationId}`),
  consultationPrestations: (consultationId: number) =>
    api.get(`consultations/prestations/${consultationId}`),
  consultationSummary: (consultationId: number) =>
    api.get(`consultations/summary/${consultationId}`),
  consultationSummaryENT: (consultationId: number) =>
    api.get(`consultations/summaryENT/${consultationId}`),
  consultationSummaryCOM: (consultationId: number) =>
    api.get(`consultations/summaryCOM/${consultationId}`),
  consultationDevis: (consultationId: number) => api.get(`consultations/devis/${consultationId}`),
  consultationQuestions: (consultationId: number) =>
    api.get(`consultations/questions/${consultationId}`),

  availableCompanies: (data: InitConsultationRequestData) =>
    api.get(StaticPostEndpoints.AvailableCompanies, data),

  // NAF
  nafs: (params: NafsQueryParams) => api.get(StaticGetEndpoints.Nafs, params),

  allNaf: () => api.get(StaticGetEndpoints.AllNaf),
  allActiveNaf: () => api.get(StaticGetEndpoints.AllActiveNaf),
  allNafDomains: () => api.get(StaticGetEndpoints.AllNafDomains),

  updateNaf: (data: NAF) => api.post(StaticPostEndpoints.UpdateNaf, data),
});
